import React, { useState, useEffect } from 'react';

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [mobileActive, setMobileActive] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const smoothScroll = (e, target) => {
    e.preventDefault();
    const element = document.querySelector(target);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
      setMobileActive(false);
    }
  };

  return (
    <nav id="navbar" className={scrolled ? 'scrolled' : ''}>
      <div className="nav-container">
        <div className="logo" style={{cursor: 'pointer'}} onClick={e => smoothScroll(e, '#home')}>
          <div className="logo-icon">
            <img src="/images/Logo.PNG" alt="Logo" style={{width: '100%', height: '100%'}} />
          </div>
          Zentak Solutions
        </div>
        <ul className={`nav-links ${mobileActive ? 'active' : ''}`}>
          <li><a href="#home" onClick={(e) => smoothScroll(e, '#home')}>Home</a></li>
          <li><a href="#services" onClick={(e) => smoothScroll(e, '#services')}>Services</a></li>
          {/* Portfolio link removed as requested */}
          <li><a href="#pricing" onClick={(e) => smoothScroll(e, '#pricing')}>Pricing</a></li>
          <li><a href="#process" onClick={(e) => smoothScroll(e, '#process')}>Our Process</a></li>
          <li><a href="#faq" onClick={(e) => smoothScroll(e, '#faq')}>FAQ</a></li>
          <li><a href="#contact" onClick={(e) => smoothScroll(e, '#contact')}>Contact</a></li>
        </ul>
        <div className="menu-toggle" onClick={() => setMobileActive(!mobileActive)}>
          <span></span><span></span><span></span>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;